var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDownDeepBlueMain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.55333 9.56366L15.786 1.57717C16.0713 1.26211 16.0713 0.751303 15.786 0.436245C15.5007 0.121187 15.0381 0.121187 14.7528 0.436245L8 7.89295L1.24723 0.436245C0.961909 0.121187 0.499312 0.121187 0.213991 0.436245C-0.0713291 0.751303 -0.0713291 1.26211 0.213991 1.57717L7.44667 9.56366C7.57636 9.70687 7.74268 9.78498 7.91232 9.798H8.08768C8.25732 9.78498 8.42364 9.70687 8.55333 9.56366Z",
    fill: "#01313D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownDeepBlueMain);
export default __webpack_public_path__ + "static/media/arrow-down-deep-blue-main.8ba9bdd85b5067c66e7d65261eb8e27d.svg";
export { ForwardRef as ReactComponent };